import { useState } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

export default function ResetAppDialog({ isOpen, onDismiss, onReset }) {
  const { t } = useTranslation();
  const [isProcessing, setIsProcessing] = useState(false);

  return (
    <Dialog
      isOpen={isOpen}
      isProcessing={isProcessing}
      heading={t("myAccount.resetAppDialog.heading")}
      text={t("myAccount.resetAppDialog.text")}
      buttons={[
        { text: t("buttons.cancel"), onClick: onDismiss },
        {
          text: t("buttons.reset"),
          onClick: () => {
            setIsProcessing(true);
            onReset();
          }
        }
      ]}
    />
  );
}
